export default "__VITE_ASSET__BvmU02$n__";